import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { bills } from "data/actions";
import MenuLink from "components/Navigation/MenuLink";
import FileDownload from "material-ui/svg-icons/file/file-download";

import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";
import Price from "components/Formaters/Price";
import Delete from "components/Buttons/Delete";
import * as os from "osutil";

import Subheader from "material-ui/Subheader";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";

import FloatingActionButton from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";

class BillsPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    console.log("Bills");
    this.props.actions.fetchBills(this.props.user.accountid);
  }

  renderBills = bills => {
    return _.map(bills, (bill, key) => {
      var count = 0,
        price = 0,
        date = 0;
      var description = "";
      var created = bill.created ? os.formatDateTime(bill.created) : "";
      var link = bill.pdf ? (
        <a download href={bill.pdf}>
          <FileDownload />
        </a>
      ) : null;

      return (
        <ClickableRow key={bill.key}>
          <ClickableRowColumn>{created}</ClickableRowColumn>
          <ClickableRowColumn>{bill.description}</ClickableRowColumn>
          <ClickableRowColumn>
            <Price value={bill.amount} />
          </ClickableRowColumn>
          <ClickableRowColumn>{bill.ocr}</ClickableRowColumn>
          <ClickableRowColumn>{link}</ClickableRowColumn>
        </ClickableRow>
      );
    });
  };

  renderBillsTable = bills => {
    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderColumn>Datum</TableHeaderColumn>
            <TableHeaderColumn>Beskrivning</TableHeaderColumn>
            <TableHeaderColumn>Belopp</TableHeaderColumn>
            <TableHeaderColumn>OCR</TableHeaderColumn>
            <TableHeaderColumn>PDF</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody>{this.renderBills(bills)}</TableBody>
      </Table>
    );
  };
  render() {
    const bills = this.props.bills;
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Översikt">
          <div>
            <p>
              Antal fakturor: <b>{this.props.count}</b>
            </p>
          </div>
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <PageBlock header={true} label="Fakturor">
          {!bills || bills.length === 0 ? (
            <span>Inga fakturor</span>
          ) : (
            this.renderBillsTable(this.props.bills)
          )}
        </PageBlock>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  var list = os.collection_to_array(state.bills.list.data);
  list = list.sort(t => t.created);
  return {
    bills: list,
    count: list.length,
    sum: list.reduce((a, b) => a + parseInt(b.amount), 0),

    user: state.auth.user,
    pending: state.bills.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...bills }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(BillsPage);



// WEBPACK FOOTER //
// ./src/pages/billing/Bills.jsx